import React from 'react'
import { CashOutline, TicketOutline } from 'react-ionicons'

interface ICampaignListProps {
    name: string;
    totalSold: number;
    totalRevenue: number;
    payoutDate: any;
}
const CampaignsCardBody: React.FC<ICampaignListProps> = (props: any) => {
    return <div style={{ width: '100%' }}>
        <h6 className='cut-text'>
            {props.name}
        </h6>
        <div style={{ width: '100%', paddingBottom: '20px', paddingTop: '5px' }}>
            <div style={{ width: '50%', float: 'left' }}>
                <div style={{ float: 'left', width: '20%' }}>
                    <button className={'new-icon'} style={{ float: 'left', }}>
                        <TicketOutline />
                    </button>
                </div>
                <div className={"cut-text sexyBlack"} style={{ float: 'right', width: '80%', paddingLeft: '10px', paddingTop: 2 }}>
                    {(props.totalSold).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                </div>
                <p />
            </div>
            <div style={{ width: '50%', float: 'right' }}>
                <div style={{ float: 'left', width: '20%' }}>
                    <button className={props.payoutDate ? 'new-icon payout' : 'new-icon'} style={{ float: 'left' }}>
                        <CashOutline color={props.payoutDate ? '#1931b9' : '#242d51'}/>
                    </button>
                </div>
                <div className={"cut-text sexyBlack"} style={{ float: 'right', width: '80%', paddingLeft: '10px', paddingTop: 2 }}>
                    ${
                        props.totalRevenue === 0 ? '0' : (props.totalRevenue / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                    }
                </div>
                <p />
            </div>
        </div>
    </div>
}

export default CampaignsCardBody;


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsPage/CampaignCard.Body.tsx